import moment from 'moment';

import { ImmigrationStatus as API } from '@src/api/types';
import { ImmigrationStatus as Data } from '@src/types';

const Factory = (api: API): Data => ({
  // tripAdvise: api.tripAdvise,
  planType: api.planType,
  hasAccess: api.hasAccess,
  daysRemaining: api.daysRemaining,
  totalDays: api.totalDays,
  beginDate: api.beginDate,
  expirationDate: api.expirationDate,
});

export default Factory;
